// import React, { useRef, useState, useEffect } from "react";
// // import { useLocation } from "react-router-dom";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const EventsListPage = ({ events, title }) => {
//   // const location = useLocation();
//   // const { events, title } = location.state || { events: [], title: "" };
//   const scrollRef = useRef(null);
//   const [showArrows, setShowArrows] = useState(false);

//   const checkScrollability = () => {
//     if (scrollRef.current) {
//       setShowArrows(
//         scrollRef.current.scrollWidth > scrollRef.current.clientWidth
//       );
//     }
//   };

//   const scroll = (direction) => {
//     if (scrollRef.current) {
//       const scrollAmount = 320;
//       scrollRef.current.scrollBy({
//         left: direction === "left" ? -scrollAmount : scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };

//   useEffect(() => {
//     checkScrollability();
//     window.addEventListener("resize", checkScrollability);
//     return () => {
//       window.removeEventListener("resize", checkScrollability);
//     };
//   }, [events]);

//   return (
//     <section className="bg-[#fdfcf7] py-16 px-4 sm:px-8 lg:px-16 relative">
//       <div className="max-w-7xl mx-auto relative">
//         <h2 className="text-4xl font-bold mb-12 text-center">{title}</h2>

//         {events.length === 0 ? (
//           <p className="text-center text-gray-500">No events found.</p>
//         ) : (
//           <div className="relative">
//             {/* Left Arrow */}
//             {showArrows && (
//               <button
//                 onClick={() => scroll("left")}
//                 className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               >
//                 <ChevronLeft size={24} />
//               </button>
//             )}

//             {/* Scrollable Container */}
//             <div
//               ref={scrollRef}
//               className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide scroll-smooth"
//             >
//               {events.map((event) => (
//                 <div
//                   key={event.id}
//                   className="bg-white rounded-2xl overflow-hidden shadow-md flex-shrink-0 w-[300px] hover:shadow-xl transition-shadow duration-300"
//                 >
//                   <img
//                     src={event.image}
//                     alt={event.title}
//                     className="w-full h-[250px] object-cover"
//                   />
//                   <div className="p-6 flex flex-col justify-between flex-grow border-t border-gray-200">
//                     <div>
//                       <h3 className="text-xl font-bold text-black leading-snug mb-1">
//                         {event.title}
//                       </h3>
//                       <p className="text-gray-500 text-sm">{event.date}</p>
//                     </div>
//                     <div className="mt-6 pt-4 border-t border-gray-200 flex items-center justify-between">
//                       <span className="font-semibold text-black">
//                         Read More
//                       </span>
//                       <span className="text-xl font-bold">→</span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Right Arrow */}
//             {showArrows && (
//               <button
//                 onClick={() => scroll("right")}
//                 className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
//               >
//                 <ChevronRight size={24} />
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default EventsListPage;
import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const EventsListPage = ({ events, title }) => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
    checkScrollPosition(); // Initial check

    return () => {
      currentRef?.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, [events]);

  return (
    <section className="bg-[#fdfcf7] py-16 px-4 sm:px-8 lg:px-16 relative">
      <div className="max-w-7xl mx-auto relative">
        <h2 className="text-4xl font-bold mb-12 text-center uppercase">
          {title}
        </h2>

        {events.length === 0 ? (
          <p className="text-center text-gray-500">No events found.</p>
        ) : (
          <div className="relative">
            {/* Left Arrow - only shows when needed */}
            {showLeftArrow && (
              <button
                onClick={() => scroll("left")}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
                aria-label="Scroll left"
              >
                <ChevronLeft size={24} />
              </button>
            )}

            {/* Scrollable Container */}
            <div
              ref={scrollRef}
              className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide scroll-smooth"
              style={{ scrollBehavior: "smooth" }}
            >
              {events.map((event) => (
                <Link to={`/events/${event.id}`} key={event.id}>
                  <div
                    key={event.id}
                    className="bg-white rounded-2xl overflow-hidden shadow-md flex-shrink-0 w-[300px] hover:shadow-xl transition-shadow duration-300"
                  >
                    <img
                      src={event?.imageUrls[0]}
                      alt={event.title}
                      className="w-full h-[250px] object-cover"
                    />
                    <div className="p-6 flex flex-col justify-between flex-grow border-t border-gray-200">
                      <div>
                        <h3 className="text-xl font-bold text-black leading-snug mb-1">
                          {event.title}
                        </h3>
                        <p className="text-gray-500 text-sm">{event.date}</p>
                      </div>
                      <div className="mt-6 pt-4 border-t border-gray-200 flex items-center justify-between">
                        <span className="font-semibold text-black">
                          Read More
                        </span>
                        <span className="text-xl font-bold">→</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Right Arrow - only shows when needed */}
            {showRightArrow && (
              <button
                onClick={() => scroll("right")}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
                aria-label="Scroll right"
              >
                <ChevronRight size={24} />
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default EventsListPage;
